import {
  Print,
  ProductOrderListRequest,
} from "@/api/models/product_order/ProductOrderListRequest";
import { CancelablePromise, OpenAPI, type Response } from "@/api";
import { ProductOrderListResponse } from "@/api/models/product_order/ProductOrderListResponse";
import { request as __request } from "@/api/core/request";
import { ToDeleteRequest } from "@/utils/slice";
import { ProductOrderUpdateRequest } from "@/api/models/product_order/ProductOrderUpdateRequest";

export class ProductOrderService {
  public static Delete(body: number): CancelablePromise<Response> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/admin/product/order",
      body: ToDeleteRequest(body),
    });
  }

  public static Drop(body: number): CancelablePromise<Response> {
    return __request(OpenAPI, {
      method: "DELETE",
      url: "/admin/product/order/drop",
      body: ToDeleteRequest(body),
    });
  }

  public static Update(
    body: ProductOrderUpdateRequest
  ): CancelablePromise<Response> {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/admin/product/order",
      body: body,
    });
  }

  public static ListAll(
    body: ProductOrderListRequest
  ): CancelablePromise<ProductOrderListResponse> {
    return __request(OpenAPI, {
      method: "GET",
      url: "/admin/product/order",
      body: body,
    });
  }

  public static PostPrint(body: Print) {
    return __request(OpenAPI, {
      method: "PUT",
      url: "/print/add",
      body: body,
    });
  }
}
